 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountDashboard":"AccountDashboard","Blog":"Blog","BlogpostList":"BlogpostList","BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate":"BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate","BlogpostSingle":"BlogpostSingle","ClubSingle":"ClubSingle","ForumCreate":"ForumCreate","ForumSingle":"ForumSingle","TournamentCreate":"TournamentCreate","ClubList":"ClubList","ClubLobbies":"ClubLobbies","ClubStats":"ClubStats","ForfunServerList":"ForfunServerList","ForfunStats":"ForfunStats","ForumList":"ForumList","LobbyList":"LobbyList","LobbySingle":"LobbySingle","Login":"Login","NotificationList":"NotificationList","NotificationSingle":"NotificationSingle","PracticeList~TeamList":"PracticeList~TeamList","PracticeList":"PracticeList","TeamList":"TeamList","PremiumPage":"PremiumPage","RankedStats":"RankedStats","RoomList":"RoomList","RoomSingle":"RoomSingle","Support":"Support","TeamCreate":"TeamCreate","TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle":"TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle","TeamSingle":"TeamSingle","TournamentAdmin":"TournamentAdmin","TournamentMatches":"TournamentMatches","TournamentSingle":"TournamentSingle","TournamentStats":"TournamentStats","UserSingle":"UserSingle","TournamentBracket":"TournamentBracket","TournamentList":"TournamentList","WallOfShame":"WallOfShame"}[chunkId]||chunkId) + "." + {"AccountDashboard":"49838fba","Blog":"b9bd7569","BlogpostList":"772c2b87","BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate":"8cf75fec","BlogpostSingle":"2b63c6ab","ClubSingle":"54a1c6e0","ForumCreate":"04aae733","ForumSingle":"b77a47fc","TournamentCreate":"d56169cd","ClubList":"70870519","ClubLobbies":"673f031a","ClubStats":"aa1479cf","ForfunServerList":"670b21de","ForfunStats":"0e6543fc","ForumList":"83bc2f2a","LobbyList":"7a318984","LobbySingle":"f87767ca","Login":"66ca0833","NotificationList":"0f9578c3","NotificationSingle":"71426365","PracticeList~TeamList":"530d01b3","PracticeList":"ddb9de60","TeamList":"52697569","PremiumPage":"9bc439f3","RankedStats":"791d69ca","RoomList":"ac1619e6","RoomSingle":"e7ac5df4","Support":"3513ef9b","TeamCreate":"06db7fc2","TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle":"82bf1f38","TeamSingle":"964430fe","TournamentAdmin":"348ab2ed","TournamentMatches":"eee6e86a","TournamentSingle":"e58fe52c","TournamentStats":"b01465f5","UserSingle":"e9316479","TournamentBracket":"ff8df3b7","TournamentList":"6eb54625","WallOfShame":"ff178c8d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountDashboard":1,"Blog":1,"BlogpostList":1,"BlogpostSingle":1,"ClubSingle":1,"ForumCreate":1,"ForumSingle":1,"TournamentCreate":1,"ClubList":1,"ClubLobbies":1,"ClubStats":1,"ForfunServerList":1,"ForfunStats":1,"ForumList":1,"LobbyList":1,"LobbySingle":1,"Login":1,"NotificationList":1,"NotificationSingle":1,"PracticeList~TeamList":1,"PracticeList":1,"TeamList":1,"PremiumPage":1,"RankedStats":1,"RoomList":1,"RoomSingle":1,"Support":1,"TeamCreate":1,"TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle":1,"TeamSingle":1,"TournamentAdmin":1,"TournamentMatches":1,"TournamentSingle":1,"TournamentStats":1,"UserSingle":1,"TournamentBracket":1,"TournamentList":1,"WallOfShame":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AccountDashboard":"AccountDashboard","Blog":"Blog","BlogpostList":"BlogpostList","BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate":"BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate","BlogpostSingle":"BlogpostSingle","ClubSingle":"ClubSingle","ForumCreate":"ForumCreate","ForumSingle":"ForumSingle","TournamentCreate":"TournamentCreate","ClubList":"ClubList","ClubLobbies":"ClubLobbies","ClubStats":"ClubStats","ForfunServerList":"ForfunServerList","ForfunStats":"ForfunStats","ForumList":"ForumList","LobbyList":"LobbyList","LobbySingle":"LobbySingle","Login":"Login","NotificationList":"NotificationList","NotificationSingle":"NotificationSingle","PracticeList~TeamList":"PracticeList~TeamList","PracticeList":"PracticeList","TeamList":"TeamList","PremiumPage":"PremiumPage","RankedStats":"RankedStats","RoomList":"RoomList","RoomSingle":"RoomSingle","Support":"Support","TeamCreate":"TeamCreate","TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle":"TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle","TeamSingle":"TeamSingle","TournamentAdmin":"TournamentAdmin","TournamentMatches":"TournamentMatches","TournamentSingle":"TournamentSingle","TournamentStats":"TournamentStats","UserSingle":"UserSingle","TournamentBracket":"TournamentBracket","TournamentList":"TournamentList","WallOfShame":"WallOfShame"}[chunkId]||chunkId) + "." + {"AccountDashboard":"01e1ae81","Blog":"7b2aad13","BlogpostList":"7f3d3961","BlogpostSingle~ClubSingle~ForumCreate~ForumSingle~TournamentCreate":"31d6cfe0","BlogpostSingle":"9a9cf463","ClubSingle":"5cb6058e","ForumCreate":"01e1ae81","ForumSingle":"551ea040","TournamentCreate":"933d4575","ClubList":"225bc3fb","ClubLobbies":"3e7ab0e8","ClubStats":"b94bb16d","ForfunServerList":"348b0637","ForfunStats":"01e1ae81","ForumList":"135811fe","LobbyList":"3e7ab0e8","LobbySingle":"311eae7a","Login":"41d1a345","NotificationList":"73e7d4d3","NotificationSingle":"05b3e340","PracticeList~TeamList":"d068cb44","PracticeList":"384be786","TeamList":"78407957","PremiumPage":"83096534","RankedStats":"7f2ea20c","RoomList":"8f2dd63e","RoomSingle":"b4c6b5e4","Support":"6fd6dda1","TeamCreate":"382dd9cc","TeamSingle~TournamentAdmin~TournamentMatches~TournamentSingle~TournamentStats~UserSingle":"dd1d6337","TeamSingle":"03e99319","TournamentAdmin":"b9b4100a","TournamentMatches":"388faff0","TournamentSingle":"cde4d357","TournamentStats":"0f4cb689","UserSingle":"cfaa886d","TournamentBracket":"b36cd6bb","TournamentList":"01e1ae81","WallOfShame":"8bd4140c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
